import { render, staticRenderFns } from "./averageClinic.vue?vue&type=template&id=4fe256b4"
import script from "./averageClinic.vue?vue&type=script&lang=js"
export * from "./averageClinic.vue?vue&type=script&lang=js"
import style0 from "./averageClinic.vue?vue&type=style&index=0&id=4fe256b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports